<template>
  <div>
    <div class="flex flex-row items-center pb-4">
      <h2 class="text-headline-medium grow">{{ $t('coaching.coacheeObjectives.title') }}</h2>
      <div class="flex items-center justify-end gap-1">
        <BaseTextButton
          color="text"
          icon="archive"
          class="text-on-surface-variant!"
          size="M"
          @click="openArchivedObjectives"
        >
          {{ $t('coaching.objectives.archived.action') }}
        </BaseTextButton>
        <BaseTextButton color="filled" icon="add" size="M" @click="createObjective">
          {{ $t('objective.create.action') }}
        </BaseTextButton>
      </div>
    </div>
    <LoadingWrapper :state="status">
      <MemberObjectivesContent
        :status="status"
        :objectives="data.objectives"
        :feedback-topics="feedbackTopics"
        :show-form="showForm"
        :creatable-objective="creatableObjective"
        @create="createObjective"
        @cancel-create="cancelCreateObjective"
        @save="saveObjective"
      />
      <UnsavedChangesDialog
        :is-open="showConfirmDialog"
        @confirm="confirmLeave"
        @dismiss="cancelLeave"
      />
    </LoadingWrapper>
  </div>
</template>

<script lang="ts" setup>
  import { computed, watch } from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  import MemberObjectivesContent from '@/core/components/objective/MemberObjectivesContent.vue'
  import BaseTextButton from '@/core/components/base/button/text-button/BaseTextButton.vue'
  import { useCoacheeObjectives } from '@/core/composables/use-coachee-objectives'
  import { useCompleteFeedbackTopics } from '@/core/composables/use-complete-feedback-topics'
  import { useUnsavedChanges } from '@/core/composables/use-unsaved-changes'
  import UnsavedChangesDialog from '@/core/components/unsaved-changes-dialog/UnsavedChangesDialog.vue'
  import LoadingWrapper from '@/core/components/loading/LoadingWrapper.vue'

  const route = useRoute()
  const router = useRouter()
  const coacheeId = computed(() => route.params.id as string)
  const {
    data,
    status,
    showForm,
    creatableObjective,
    createObjective,
    cancelCreateObjective,
    saveObjective,
  } = useCoacheeObjectives(coacheeId)
  const { showConfirmDialog, confirmLeave, cancelLeave, setSourceDirty } = useUnsavedChanges()
  const { data: topicsData } = useCompleteFeedbackTopics()

  const feedbackTopics = computed(() => topicsData.value?.feedbackTopics ?? [])

  const createFormHasContent = computed(() => {
    if (!showForm.value) {
      return false
    }
    return !!(
      creatableObjective.title?.trim() ||
      creatableObjective.description?.trim() ||
      creatableObjective.feedbackTopicId
    )
  })

  watch(
    createFormHasContent,
    (dirty) => {
      setSourceDirty('create-form', dirty)
    },
    { immediate: true },
  )

  const openArchivedObjectives = () => {
    router.push({
      name: 'coachee-archived-objectives',
      params: { id: coacheeId.value },
    })
  }
</script>
